{
  "EMOJI": {
    "PLACEHOLDER": "Cari emoji",
    "NOT_FOUND": "Tidak ditemukan emoji yang sesuai dengan pencarian Anda",
    "REMOVE": "Hapus"
  },
  "EMOJI_ICON_PICKER": {
    "TABS": {
      "ICONS": "Icons",
      "EMOJIS": "Emojis"
    },
    "SEARCH_EMOJI": "Search emoji…",
    "SEARCH_ICON": "Search icons…",
    "FREQUENTLY_USED": "Frequently used",
    "NO_EMOJI": "Tidak ditemukan emoji yang sesuai dengan pencarian Anda",
    "NO_ICON": "No icons match your search",
    "REMOVE": "Hapus",
    "STYLE": {
      "OUTLINE": "Outline icons",
      "FILLED": "Filled icons"
    },
    "COLORS": {
      "SLATE": "Slate",
      "RED": "Red",
      "ORANGE": "Orange",
      "AMBER": "Amber",
      "GREEN": "Green",
      "TEAL": "Teal",
      "BLUE": "Blue",
      "INDIGO": "Indigo",
      "VIOLET": "Violet",
      "PINK": "Pink"
    }
  }
}
